import ServicePageTemplate from "@/components/ServicePageTemplate";
import BrowserStackCarousel from "@/components/BrowserStackCarousel";
import { Globe } from "lucide-react";
import { usePageMeta } from "@/hooks/usePageMeta";
import { useApiData } from "@/hooks/useApiData";
import type { Project } from "@shared/types";

export default function WebDevelopment() {
  usePageMeta({
    title: "בניית אתרים: איפיון, פיתוח ועיצוב מקצועי ומותאם אישית | upsite",
    description: "היום בניית אתרים יפים פשוט לא מספיקה. באפסייט אנחנו בונים אתרים מהירים, מותאמי SEO ומעוצבים להמרה, שמשאירים למתחרים אבק. לחצו לבניית נכס אמיתי",
  });

  const { data: projects } = useApiData<Project[]>("/projects");

  return (
    <ServicePageTemplate
      icon={Globe}
      title="בניית אתר חדש או שדרוג אתר קיים"
      subtitle="בניית אתרים"
      description="אנחנו בונים אתרים מודרניים, מהירים ומותאמים לקידום ולהמרות. בין אם מדובר באתר חדש מאפס או בשדרוג אתר קיים – אנחנו יודעים איך לעשות את זה נכון."
      image="/images/services/web-development.jpeg"
      benefits={[
        "אפיון צרכים ויעדים עסקיים",
        "UX/UI מודרני שמותאם גם למובייל וגם להמרות",
        "פיתוח מהיר, נקי ומוכן לקידום",
        "מעבר או שדרוג אתר בלי לפגוע במיקומים ובנכסים שכבר נצברו",
        "אתרים מותאמים לסטנדרטים של גוגל",
        "תמיכה טכנית ותחזוקה שוטפת",
      ]}
      extraHeroButtons={[{ label: "הפרויקטים שלנו", href: "/projects" }]}
      processSteps={[
        { title: "אפיון ותכנון", desc: "הבנת הצרכים העסקיים, קהל היעד והיעדים – ובניית תוכנית עבודה מפורטת." },
        { title: "עיצוב UX/UI", desc: "עיצוב חוויית משתמש מודרנית שמותאמת למובייל ומכוונת להמרות." },
        { title: "פיתוח ובנייה", desc: "פיתוח האתר בטכנולוגיות מתקדמות עם דגש על מהירות, נגישות וקידום." },
        { title: "בדיקות והשקה", desc: "בדיקות מקיפות, אופטימיזציה והשקה חלקה עם מעבר מבוקר." },
      ]}
      heroSide={
        projects && projects.length > 0 ? (
          <BrowserStackCarousel projects={projects} />
        ) : null
      }
    />
  );
}
